/**
 * Authentication Guard
 *
 * Purpose: Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */

import { Navigate, useLocation } from 'react-router-dom'
import { isAuthenticated } from '@/core/auth'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation()
  const authenticated = isAuthenticated()

  // Redirect to login if not authenticated, preserving intended destination
  if (!authenticated) {
    const redirectTo = location.pathname + location.search
    return <Navigate to={`/auth/login?redirect=${encodeURIComponent(redirectTo)}`} replace />
  }

  return <>{children}</>
}
